
import { computed, defineComponent, onMounted, Ref, ref } from "vue";
import { useAPIInfo, useAPIParams, useAPIReturnParams } from "@/hooks/doc";
import { IGlobalState } from "@/store";
import { useStore } from "vuex";
import { IAPIParam } from "@/typings/doc";

export interface IVersionItem {
  id: string;
  version: string;
  paramsCount: number;
  publicpParamsCount: number;
}

export default defineComponent({
  props: {
    apiId: {
      type: String,
      default: "",
    },
    groupid: {
      type: String,
      default: "",
    },
    groupname: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const store = useStore<IGlobalState>();
    const apiBaseInfo = computed(() => store.state.doc.apiDetail.apiBaseInfo);
    // const apiParams = computed(() => store.state.doc.apiDetail.apiParams);

    const apiParams = computed({
      get: () => store.state.doc.apiDetail.apiParams,
      set: (val) => {
        store.state.doc.apiDetail.apiParams = val;
      },
    });
    const apiParamsTemp: Ref<IAPIParam[]> = ref([])
    // const apiReturnParams = computed(
    //   () => store.state.doc.apiDetail.apiReturnParams
    // );
    const apiReturnParamsTemp: any = ref([])
    const apiReturnParams = computed({
      get: () => store.state.doc.apiDetail.apiReturnParams,
      set: (val) => {
        store.state.doc.apiDetail.apiReturnParams = val;
      },
    });
    const apiPublicParamsTemp: any = ref([])
    const apiPublicParams = ref(
      [
        {
          paramName: 'appId',
          type: 'string',
          isRequire: true,
          description: '应用id'
        },
        {
          paramName: 'timestamp',
          type: 'long',
          isRequire: true,
          description: '当前时间戳毫秒'
        },
        {
          paramName: 'sign',
          type: 'string',
          isRequire: true,
          description: '签名'
        },
        {
          paramName: 'version',
          type: 'string',
          isRequire: true,
          description: '1.0'
        }
      ]
    )

    const requstHtml = ref('')
    const isShowVersion = ref(false);
    const versionList: Ref<IVersionItem[]> = ref([])
    const curVersionId = ref('')
    const versionDesc = ref('')

    /**
     * 获取接口详情
     */
    const getAPIInfo = async () => {
      await useAPIInfo(store, props.apiId);
    };
    /**
     * 获取接口参数
     */
    const getAPIParams = async () => {
      await useAPIParams(store, props.apiId);
    };
    /**
     * 获取接口返回参数
     */
    const getAPIReturnParams = async () => {
      await useAPIReturnParams(store, props.apiId);
    };
    /**
     * 根据接口地址和参数拼接请求示例
     */
    const appendRequestUrl = async () => {
      const perStr = 'curl --location --request POST "https://{host}'
      let paramsStr = '';
      apiParamsTemp.value.forEach((item) => {
        let joinStr = '&';
        if (!paramsStr) {
          joinStr = '?';
        }
        if (item.isRequire)
          paramsStr += joinStr + item.paramName + '={' + item.paramName + '}'
      })
      apiPublicParamsTemp.value.forEach((item: any) => {
        const joinStr = '&';
        if (item.isRequire)
          paramsStr += joinStr + item.paramName + '={' + item.paramName + '}'
      })
      requstHtml.value = perStr + apiBaseInfo.value.url + paramsStr + '"';

    };
    /**
     *  根据环境变量随机生成版本号集合数据
     */
    const getVersionData = () => {
      const maxVersion = Number(process.env.VUE_APP_MAX_VERSION);
      // const maxParamsCount = apiParams.value.length;
      // const maxPublicParamsCount = apiPublicParams.value.length;
      for (let i = 0; i < maxVersion; i++) {
        // 下标字符串
        const indexStr = i + 1;
        // let minParamsCount = 1, minPublicParamsCount = 1;
        // if (i > versionList.value.length) {
        //   minParamsCount = versionList.value[i - 1].paramsCount;
        //   minPublicParamsCount = versionList.value[i - 1].publicpParamsCount;
        // }
        // let paramsCount = 1;
        const paramsCount = i > 1 ? 7 : i > 0 ? 5 : 2;
        const publicpParamsCount = i > 1 ? 4 : i > 0 ? 3 : 2;

        // if (maxParamsCount > minParamsCount)
        // 随机生成展示的参数个数 paramsCount = Math.round(Math.random() * maxParamsCount);
        // paramsCount = Math.floor(Math.random() * (maxParamsCount - minParamsCount) + minParamsCount);
        // if (maxPublicParamsCount > minPublicParamsCount)
        // 随机生成展示的参数个数 publicpParamsCount = Math.round(Math.random() * maxPublicParamsCount);
        // publicpParamsCount = Math.floor(Math.random() * (maxPublicParamsCount - minPublicParamsCount) + minPublicParamsCount);
        versionList.value.push({
          id: indexStr.toString(),
          version: indexStr + '.0',
          paramsCount: paramsCount,
          publicpParamsCount: publicpParamsCount
        })
      }
      versionList.value = versionList.value.reverse();
      // console.log(JSON.stringify(versionList.value));
      curVersionId.value = versionList.value[0].id;
    };
    /**
     * 根据当前版本号需要展示的参数个数 处理参数数据
     */
    const calParamsData = () => {
      const curVersion = versionList.value.filter((item: IVersionItem) => {
        return item.id === curVersionId.value;
      })[0];
      if (curVersion) {
        const apiParamsTemp2 = apiParams.value.concat();
        const apiPublicParamsTemp2 = apiPublicParams.value.concat();
        const apiReturnParamsTemp2 = apiReturnParams.value.concat();
        // console.log('old=' + JSON.stringify(apiParamsTemp2));
        // apiParamsTemp2.splice(curVersion.paramsCount)
        // console.log('new=' + JSON.stringify(apiParamsTemp2));
        // apiParamsTemp.value = apiParamsTemp2.concat();
        // apiPublicParamsTemp2.splice(curVersion.publicpParamsCount)
        // apiPublicParamsTemp.value = apiPublicParamsTemp2.concat();
        // apiParamsTemp.value = apiParamsTemp.value.concat(apiPublicParamsTemp.value);
        apiPublicParamsTemp2.splice(Number(curVersion.id) + 1)
        apiPublicParamsTemp.value = apiPublicParamsTemp2.concat();
        apiParamsTemp.value = apiParamsTemp2.concat(apiPublicParamsTemp.value);
        apiReturnParamsTemp2.splice(Number(curVersion.id) + 1)
        apiReturnParamsTemp.value = apiReturnParamsTemp2.concat();

        if (curVersion.id === "1")
          versionDesc.value = 'V' + curVersion.version + ' 需要携带请求公共参数：appId（应用id）、timestamp（当前时间戳）。'
        if (curVersion.id === "2")
          versionDesc.value = 'V' + curVersion.version + ' 需要携带请求公共参数：appId（应用id）、timestamp（当前时间戳），新增参数：sign（签名）；' + '新增返回参数：' + apiReturnParams.value[Number(curVersion.id)].fieldName + '（' + apiReturnParams.value[Number(curVersion.id)].description + '）。';
        if (curVersion.id === "3")
          versionDesc.value = 'V' + curVersion.version + ' 需要携带请求公共参数：appId（应用id）、timestamp（当前时间戳）、sign（签名），新增参数：version（版本号）；' + '新增返回参数：' + apiReturnParams.value[Number(curVersion.id)].fieldName + '（' + apiReturnParams.value[Number(curVersion.id)].description + '）。';

        appendRequestUrl();
      }
    };
    /**
     * 页面一开始加载
     */
    onMounted(async () => {
      await getAPIInfo();
      await getAPIParams();
      await getAPIReturnParams();
      if (apiParams.value.length > 0)
        apiParamsTemp.value = apiParams.value.concat();
      if (apiPublicParams.value.length > 0)
        apiPublicParamsTemp.value = apiPublicParams.value.concat();
      if (apiReturnParams.value.length > 0)
        apiReturnParamsTemp.value = apiReturnParams.value.concat();
      isShowVersion.value = Number(process.env.VUE_APP_SHOW_VERSION) === 1;
      if (isShowVersion.value) {
        getVersionData();
        calParamsData();
      }
      appendRequestUrl();
    });
    return {
      apiPublicParams,
      apiPublicParamsTemp,
      apiBaseInfo,
      apiParams,
      apiParamsTemp,
      apiReturnParams,
      apiReturnParamsTemp,
      requstHtml,
      isShowVersion,
      versionList,
      curVersionId,
      calParamsData,
      versionDesc
    };
  },
});
